<template>
  <div>

    <div class="big-orders-list">
      <div v-for="(order, idx) in orders"
           :key="order.id"
           class="order-item">

        <div class="order-grid order-grid_name">
          <div class="order-name">{{ order.orderName }}</div>
          <div class="order-table"><small>{{ $t('#TR-table') }}:</small> <b>{{ order.tableCode }}</b></div>
          <div class="order-edit" @click="onPreviewOrder(order)">
            <span class="mdi mdi-eye"></span>
          </div>
        </div>

        <div class="order-grid order-grid_date">
          <div class="order-date">{{ order.createTime | moment('DD.MM.YYYY, HH:mm') }}</div>
          <div class="order-date">{{ order.finishTime | moment('DD.MM.YYYY, HH:mm') }}</div>
          <div class="order-sum"><small>{{ $t('#TR-sum') }}:</small> <b>{{ order.orderSum / 100 }}</b></div>
        </div>

      </div>
    </div>


    <div class="small-orders-list">
      <div v-for="(order, idx) in orders"
           :key="order.id"
           class="order-item">

        <div class="order-name">{{ order.orderName }}</div>
        <div class="order-table"><small>{{ $t('#TR-table') }}:</small> <b>{{ order.tableCode }}</b></div>

        <div class="order-edit"
             @click="onPreviewOrder(order)">
          <span class="mdi mdi-eye"></span>
        </div>


        <div class="order-grid order-grid_date">
          <div class="order-date">{{ order.createTime | moment('DD.MM.YYYY, HH:mm') }}</div>
          <div class="order-date">{{ order.finishTime | moment('DD.MM.YYYY, HH:mm') }}</div>
          <div class="order-sum"><small>{{ $t('#TR-sum') }}:</small> <b>{{ order.orderSum / 100 }}</b></div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'TableOrders',
    props: {
      orders: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },

    methods: {
      onPreviewOrder(order) {
        this.$emit('onprevieworder', order);
      }
    }
  };
</script>

<style lang="stylus">

.small-orders-list {
  display: none
}

.big-orders-list {
  display: block;
}

.small-screen {
  .big-orders-list {
    display: none;
  }
  .small-orders-list {
    display: block;
  }
}



.big-orders-list {
  .order-item {
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 3px;
    border: 1px solid #dee2e6;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);

    .order-grid {
      display: grid;
    }

    .order-grid_name {
      grid-template-columns: 1fr 150px 30px;
      margin-bottom: 5px

      .order-name {
        color: c-accent;
        font-weight: bold;
      }

      .order-edit {
        width: 30px;
        height: 30px;
        background: c-accent;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
      }

      .order-table {

      }
    }

    .order-grid_date {
      grid-template-columns: 1fr 1fr 1fr;

      .order-date {
        font-size: 14px;
        font-weight: bold;
        color: md-blue-grey-600
      }

      .order-sum {
        text-align: right;
      }
    }
  }

}


.small-orders-list {
  .order-item {
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 3px;
    border: 1px solid #dee2e6;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
    position: relative;


      .order-name {
        color: c-accent;
        font-weight: bold;
      }
      .order-edit {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        background: c-accent;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
      }


    .order-grid_date {
      grid-template-columns: 1fr 1fr 1fr;

      .order-date {
        font-size: 14px;
        font-weight: bold;
        color: md-blue-grey-600
      }

      .order-sum {
        text-align: right;
      }
    }
  }
}



.darkmode {
  .big-orders-list {
    .order-item {
      background:c-dark-bg;
      border: 1px solid c-border-dark;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);

      .order-name {
        color: c-accent-dark;
      }

      .order-edit {
        background: c-accent-dark;
      }
    }
  }

  .small-orders-list {
    .order-item {
      background: c-dark-bg;
      border: 1px solid c-border-dark;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);

      .order-name {
        color: c-accent-dark;
      }
      .order-edit {
        background: c-accent-dark;
      }
    }
  }




}

</style>
